

















import FilterSharpen from "@/app/shared/filters/FilterSharpen.vue";

export default {
  name: "BaseFiltered",
  components: { FilterSharpen },
  data: function () {
    return {
      filterId: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.filterId = this.$refs.filter ? this.$refs.filter.filterId : "";
    }, 15);
  },
  props: {
    filterOptions: {
      type: Object,
      required: true,
    },
  },
  methods: {},
};
